import { CardShell, FixtureTile, TeamBadgeSlot, TitleBar } from './card-chrome';
import type { TickerRow } from '@lib/article-blocks/ticker';

type FixtureTickerCardProps = {
  rows: TickerRow[];
  gameweeks: number[];
};

export const FixtureTickerCard = ({
  rows,
  gameweeks
}: FixtureTickerCardProps) => {
  const first = gameweeks[0];
  const last = gameweeks[gameweeks.length - 1];
  // Fixed minimum per column so five gameweeks scroll on a phone rather than
  // squashing the labels into one another.
  const columns = `5rem repeat(${Math.max(
    gameweeks.length,
    1
  )}, minmax(4.5rem, 1fr))`;

  return (
    <CardShell testId="fixture-ticker-card">
      <TitleBar
        title="Fixture ticker"
        detail={first === last ? `GW${first}` : `GW${first}-GW${last}`}
      />
      <div className="-mx-1 overflow-x-auto px-1">
        <div
          className="grid items-center gap-1.5 sm:gap-2"
          style={{ gridTemplateColumns: columns }}
        >
          <div className="text-xs font-bold text-[#a5aaad] sm:text-sm">
            Team
          </div>
          {gameweeks.map((gameweek) => (
            <div
              key={`label-${gameweek}`}
              className="text-center text-xs font-bold text-[#a5aaad] sm:text-sm"
            >
              GW{gameweek}
            </div>
          ))}
          {rows.map((row) => [
            <div
              key={`team-${row.shortName}`}
              className="flex items-center gap-2 text-xs font-bold leading-none text-[#fcfcfc] sm:text-sm"
            >
              <TeamBadgeSlot shortName={row.shortName} />
              <span>{row.shortName}</span>
            </div>,
            ...row.gameweeks.map((entry) => (
              <FixtureTile
                key={`${row.shortName}-${entry.gameweek}`}
                fixtures={entry.fixtures}
                isCompact
              />
            ))
          ])}
        </div>
      </div>
    </CardShell>
  );
};
